import React from "react";
import { Icon } from "@material-ui/core";
import "../../Subscription.css";

const SubscriptionDetails = ({
	subscriptionQuantity,
	subscriptionStatus,
	nextCycleQuantity,
	subscriptionEnd,
	subscriptionSource,
	getPrice,
}) => {

	const getStatusBadgeClass = (status) => {
		switch(status?.toUpperCase()) {
			case 'ACTIVE':
				return 'active';
			case 'INACTIVE':
				return 'inactive';
			case 'CANCELED':
				return 'canceled';
			default:
				return 'pending';
		}
	};

	const endLabel =
		subscriptionStatus === "CANCELED"
			? "Access until"
			: subscriptionSource === "stripe"
				? "Renews on"
				: "Valid until";
	const billedWith =
		subscriptionSource === "stripe"
			? "Card (Stripe)"
			: subscriptionSource === "paypal"
				? "PayPal"
				: "—";

	return (
		<div className="subscription-section">
			<div className="subscription-section-header">
				<Icon className="subscription-section-icon">account_balance_wallet</Icon>
				<h2 className="subscription-section-title">Your Subscription</h2>
			</div>
			
			{subscriptionStatus && (
				<>
					<div className={`subscription-status-badge ${getStatusBadgeClass(subscriptionStatus)}`}>
						<Icon style={{ fontSize: '1rem' }}>
							{subscriptionStatus === 'ACTIVE' ? 'check_circle' : subscriptionStatus === 'CANCELED' ? 'cancel' : 'info'}
						</Icon>
						{subscriptionStatus}
					</div>

					<div className="subscription-details-grid">
						<div className="subscription-detail-row">
							<span className="subscription-detail-label">
								Hosts Quantity
							</span>
							<span className="subscription-detail-value">{subscriptionQuantity}</span>
						</div>

						<div className="subscription-detail-row">
							<span className="subscription-detail-label">Billed with</span>
							<span className="subscription-detail-value">{billedWith}</span>
						</div>

						{nextCycleQuantity ? (
							<div className="subscription-detail-row">
								<span className="subscription-detail-label">Hosts next cycle</span>
								<span className="subscription-detail-value">{nextCycleQuantity}</span>
							</div>
						) : null}

						<div className="subscription-detail-row">
							<span className="subscription-detail-label">Monthly price</span>
							<span className="subscription-detail-value price">${getPrice(subscriptionQuantity)}</span>
						</div>

						<div className="subscription-detail-row">
							<span className="subscription-detail-label">{endLabel}</span>
							<span className="subscription-detail-value">{subscriptionEnd?.slice(0, 10) || "—"}</span>
						</div>
					</div>
				</>
			)}
		</div>
	);
};

export default SubscriptionDetails;
